module.exports = __webpack_public_path__ + "resources/img/logo_hangame.fd6ef69e19b7844c41836aedca33f261.png";